import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-between" }
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = {
  key: 0,
  class: "text-4xl"
}
const _hoisted_5 = {
  key: 1,
  class: "text-4xl text-pink-600"
}

import Card from "primevue/card";
import { ref } from "vue";
import { CombinedTargetResponse } from "@evolutivelabs/quokka-common";
import Menu from "primevue/menu";
import { useCombinedTargetStore } from "@/store/combinedTarget.store";

export default /*#__PURE__*/_defineComponent({
  props: {
    combinedTarget: null
  },
  emits: ["edit-combined-target"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: "edit-combined-target"): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  combinedTarget: CombinedTargetResponse;
}




const combinedTargetStore = useCombinedTargetStore();

const menuItems = [
  {
    label: "edit",
    icon: "pi pi-pencil",
    command() {
      emits("edit-combined-target");
    },
  },
  {
    label: "delete",
    icon: "pi pi-trash",
    command() {
      combinedTargetStore.remove(props.combinedTarget.id);
    },
  },
];

const menu = ref<InstanceType<typeof Menu>>();

function toggleMenu(event: Event) {
  menu.value?.toggle(event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "shadow-2 m-3 w-3" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(props.combinedTarget.title), 1),
          (typeof props.combinedTarget.value === 'number')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.combinedTarget.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, "Value Not Found 😭"))
        ]),
        _createElementVNode("div", {
          class: "h-1rem pi pi-cog cursor-pointer",
          onClick: toggleMenu
        })
      ]),
      _createVNode(_unref(Menu), {
        ref: (_value, _refs) => {
          _refs['menu'] = _value
          menu.value = _value
        },
        popup: "",
        model: menuItems
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})